import { Link } from 'react-router-dom';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#1a1a2e] text-white font-['Orbitron'] flex flex-col">
      {/* Header */}
      <header className="p-4 flex items-center border-b border-white/10">
        <Link 
          to="/" 
          className="flex items-center gap-2 text-[#fbbf24] hover:text-[#f59e0b] transition-colors cursor-pointer"
        >
          <i className="ri-arrow-left-line text-xl"></i>
          <span className="text-sm">홈으로</span>
        </Link>
      </header>

      {/* Content */}
      <main className="flex-1 overflow-y-auto px-6 py-8 pb-safe">
        <div className="max-w-2xl mx-auto">
          <h1 className="text-3xl font-bold text-[#fbbf24] mb-8">Privacy Policy</h1>
          
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-[#fbbf24] mb-4">개인정보 수집 및 이용</h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              PinballSix(핀볼식스)는 사용자의 개인정보를 수집하지 않습니다.
              회원가입, 로그인, 결제 등 개인정보 입력이 필요한 기능이 없으며 서비스는 브라우저 환경에서 작동합니다.
            </p>
            <div className="bg-white/5 rounded-lg p-4 border border-white/10">
              <p className="text-gray-300 text-sm">
                <i className="ri-shield-check-line text-[#fbbf24] mr-2"></i>
                이름, 이메일, 전화번호 등 어떠한 개인정보도 수집하지 않습니다.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-[#fbbf24] mb-4">로컬 스토리지 사용</h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              더 나은 사용자 경험을 위해 브라우저의 로컬 스토리지를 사용할 수 있습니다.
            </p>
            <p className="text-gray-300 leading-relaxed mb-3">저장되는 정보 예시는 다음과 같습니다.</p>
            <ul className="space-y-3 mb-4">
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-line text-[#fbbf24] mt-1"></i>
                <div>
                  <span className="text-gray-300 font-semibold">게임 설정</span>
                  <p className="text-gray-400 text-sm">사운드 on/off, 진동 on/off 등</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-line text-[#fbbf24] mt-1"></i>
                <div>
                  <span className="text-gray-300 font-semibold">생성된 번호 기록</span>
                  <p className="text-gray-400 text-sm">선택적 저장</p>
                </div>
              </li>
            </ul>
            <p className="text-gray-300 text-sm">
              이 정보는 사용자의 기기에만 저장되며 서버로 전송되지 않습니다.
              브라우저 캐시를 삭제하면 모든 데이터가 제거됩니다.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-[#fbbf24] mb-4">쿠키 및 광고</h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              PinballSix는 Google AdSense와 같은 제3자 광고 서비스를 사용할 수 있습니다.
            </p>
            <p className="text-gray-300 leading-relaxed mb-4">
              Google과 같은 광고 제공업체는 쿠키를 사용하여 사용자의 방문 기록을 기반으로 맞춤형 광고를 표시할 수 있습니다.
            </p>
            <p className="text-gray-300 leading-relaxed mb-4">
              사용자는 브라우저 설정을 통해 쿠키 사용을 거부하거나 관리할 수 있습니다.
            </p>
            <div className="bg-white/5 rounded-lg p-4 border border-white/10">
              <p className="text-gray-300 text-sm mb-1">
                <i className="ri-information-line text-[#fbbf24] mr-2"></i>
                Google 광고 정책에 대한 자세한 내용은 아래 페이지에서 확인할 수 있습니다.
              </p>
              <a
                href="https://policies.google.com/technologies/ads"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="text-[#fbbf24] hover:text-[#f59e0b] text-sm underline underline-offset-2 transition-colors cursor-pointer break-all"
              >
                https://policies.google.com/technologies/ads
              </a>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-[#fbbf24] mb-4">제3자 정보 공유</h2>
            <p className="text-gray-300 leading-relaxed">
              PinballSix는 사용자의 개인정보를 수집하지 않으며 제3자와 정보를 판매하거나 공유하지 않습니다.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-[#fbbf24] mb-4">외부 링크</h2>
            <p className="text-gray-300 leading-relaxed">
              서비스에는 외부 웹사이트로 연결되는 링크가 포함될 수 있습니다.
              외부 사이트의 개인정보 보호 정책은 해당 사이트의 책임이며 PinballSix는 이에 대해 책임지지 않습니다.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-[#fbbf24] mb-4">정책 변경</h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              본 개인정보 보호 정책은 필요에 따라 업데이트될 수 있습니다.
              중요한 변경 사항이 있을 경우 서비스 내 공지를 통해 안내합니다.
            </p>
            <p className="text-gray-400 text-sm">
              최종 업데이트: 2026년 1월
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#fbbf24] mb-4">문의</h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              개인정보 보호 정책에 대한 질문이나 우려 사항이 있으시면 
              언제든지 문의해 주세요.
            </p>
            <Link 
              to="/contact" 
              className="inline-flex items-center gap-2 text-[#fbbf24] hover:text-[#f59e0b] transition-colors cursor-pointer"
            >
              <span>문의하기</span>
              <i className="ri-arrow-right-line"></i>
            </Link>
          </section>
        </div>
      </main>
    </div>
  );
}